import { NeuTooltip } from "@neutron/react";
import React from "react";

/** Thin wrapper around `<NeuTooltip>` */
export function Tooltip(props: { children: React.ReactNode, className?: string, tip?: string, position?: string }) {
    return (
        <NeuTooltip className={props.className ? props.className : ''} tip={props.tip} data-popper-placement={props.position}>
            {props.children}
        </NeuTooltip>
    )
}